import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ProductParameterFormatState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ProductParameterFormatQuery extends QueryEntity<ProductParameterFormatState> {

  constructor(protected store: Store) {
    super(store);
  }

}
